var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWdoc(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.4,
    height: 18,
    viewBox: "0 0 14.4 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "_9c1b752edcd891caaa1146045ca31b56",
    "data-name": "9c1b752edcd891caaa1146045ca31b56",
    d: "M8.5,9.2h.9a.9.9,0,1,0,0-1.8H8.5a.9.9,0,1,0,0,1.8Zm0,1.8a.9.9,0,0,0,0,1.8h5.4a.9.9,0,0,0,0-1.8Zm9.9-2.754A1.179,1.179,0,0,0,18.346,8V7.922a.963.963,0,0,0-.171-.252h0l-5.4-5.4h0a.963.963,0,0,0-.252-.171.288.288,0,0,0-.081,0,.792.792,0,0,0-.3-.1H6.7A2.7,2.7,0,0,0,4,4.7V17.3A2.7,2.7,0,0,0,6.7,20h9a2.7,2.7,0,0,0,2.7-2.7V8.246ZM13,5.069,15.331,7.4H13.9a.9.9,0,0,1-.9-.9ZM16.6,17.3a.9.9,0,0,1-.9.9h-9a.9.9,0,0,1-.9-.9V4.7a.9.9,0,0,1,.9-.9h4.5V6.5a2.7,2.7,0,0,0,2.7,2.7h2.7Zm-2.7-2.7H8.5a.9.9,0,0,0,0,1.8h5.4a.9.9,0,0,0,0-1.8Z",
    transform: "translate(-4 -2)",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWdoc);
export default __webpack_public_path__ + "static/media/wdoc.df1d60396ef6916a94bb184d5d85a547.svg";
export { ForwardRef as ReactComponent };